import { createContext, useContext } from 'react'
import { rootStore } from '../stores/RootStore'

const StoreContext = createContext(rootStore)
export const useStores = () => useContext(StoreContext)
